var cov_2kg43duu9j = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Message/messager.tsx",
      hash = "5a3c88af7e046d1f593fe3e21c12e9e96bb196da",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Message/messager.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 6
        }
      },
      "1": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 6
        }
      },
      "2": {
        start: {
          line: 17,
          column: 27
        },
        end: {
          line: 17,
          column: 48
        }
      },
      "3": {
        start: {
          line: 18,
          column: 14
        },
        end: {
          line: 18,
          column: 43
        }
      },
      "4": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 41
        }
      },
      "5": {
        start: {
          line: 20,
          column: 15
        },
        end: {
          line: 20,
          column: 31
        }
      },
      "6": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 24,
          column: 3
        }
      },
      "7": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 24
        }
      },
      "8": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "9": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 22
        }
      },
      "10": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 25
        }
      },
      "11": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 23
        }
      },
      "12": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 12
        }
      },
      "13": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 41,
          column: 3
        }
      },
      "14": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 51
        }
      },
      "15": {
        start: {
          line: 38,
          column: 15
        },
        end: {
          line: 38,
          column: 29
        }
      },
      "16": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 58
        }
      },
      "17": {
        start: {
          line: 39,
          column: 29
        },
        end: {
          line: 39,
          column: 58
        }
      },
      "18": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 25
        }
      },
      "19": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "20": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 27
        }
      },
      "21": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 70,
          column: 4
        }
      },
      "22": {
        start: {
          line: 55,
          column: 22
        },
        end: {
          line: 55,
          column: 43
        }
      },
      "23": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "24": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 24
        }
      },
      "25": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 68,
          column: 7
        }
      },
      "26": {
        start: {
          line: 62,
          column: 12
        },
        end: {
          line: 62,
          column: 39
        }
      },
      "27": {
        start: {
          line: 63,
          column: 12
        },
        end: {
          line: 63,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "getElement",
        decl: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 87
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 16
      },
      "1": {
        name: "destroy",
        decl: {
          start: {
            line: 35,
            column: 16
          },
          end: {
            line: 35,
            column: 23
          }
        },
        loc: {
          start: {
            line: 35,
            column: 44
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 35
      },
      "2": {
        name: "getComponent",
        decl: {
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 28
          }
        },
        loc: {
          start: {
            line: 53,
            column: 58
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 22
          }
        },
        loc: {
          start: {
            line: 54,
            column: 32
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 54
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 15
          },
          end: {
            line: 61,
            column: 16
          }
        },
        loc: {
          start: {
            line: 61,
            column: 23
          },
          end: {
            line: 64,
            column: 11
          }
        },
        line: 61
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        }, {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 15
          }
        }, {
          start: {
            line: 22,
            column: 19
          },
          end: {
            line: 22,
            column: 36
          }
        }],
        line: 22
      },
      "2": {
        loc: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }, {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }],
        line: 26
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 26,
            column: 15
          }
        }, {
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 26,
            column: 51
          }
        }],
        line: 26
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 58
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 39,
            column: 58
          }
        }],
        line: 39
      },
      "6": {
        loc: {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 39,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 39,
            column: 10
          }
        }, {
          start: {
            line: 39,
            column: 14
          },
          end: {
            line: 39,
            column: 27
          }
        }],
        line: 39
      },
      "7": {
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }, {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        }],
        line: 42
      },
      "8": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Message/messager.tsx";
import React from 'react';
import ReactDOM from 'react-dom';
import { messageClass } from './styles';
import Container from './Container';
import { isFunc } from '../utils/is';
import { getDefaultContainer } from '../config';
var elements = (cov_2kg43duu9j.s[0]++, {});
var components = (cov_2kg43duu9j.s[1]++, {});

function getElement(type, container) {
  cov_2kg43duu9j.f[0]++;
  var defaultContainer = (cov_2kg43duu9j.s[2]++, getDefaultContainer());
  var div = (cov_2kg43duu9j.s[3]++, document.createElement('div'));
  cov_2kg43duu9j.s[4]++;
  div.className = messageClass('_', type);
  var target = (cov_2kg43duu9j.s[5]++, defaultContainer);
  cov_2kg43duu9j.s[6]++;

  if ((cov_2kg43duu9j.b[1][0]++, container) && (cov_2kg43duu9j.b[1][1]++, isFunc(container))) {
    cov_2kg43duu9j.b[0][0]++;
    cov_2kg43duu9j.s[7]++;
    target = container();
  } else {
    cov_2kg43duu9j.b[0][1]++;
  }

  cov_2kg43duu9j.s[8]++;

  if ((cov_2kg43duu9j.b[3][0]++, container) && (cov_2kg43duu9j.b[3][1]++, container instanceof HTMLElement)) {
    cov_2kg43duu9j.b[2][0]++;
    cov_2kg43duu9j.s[9]++;
    target = container;
  } else {
    cov_2kg43duu9j.b[2][1]++;
  }

  cov_2kg43duu9j.s[10]++;
  target.appendChild(div);
  cov_2kg43duu9j.s[11]++;
  elements[type] = div;
  cov_2kg43duu9j.s[12]++;
  return div;
}

export function destroy(type) {
  cov_2kg43duu9j.f[1]++;
  cov_2kg43duu9j.s[13]++;

  if (elements[type]) {
    cov_2kg43duu9j.b[4][0]++;
    cov_2kg43duu9j.s[14]++;
    ReactDOM.unmountComponentAtNode(elements[type]);
    var el = (cov_2kg43duu9j.s[15]++, elements[type]);
    cov_2kg43duu9j.s[16]++;

    if ((cov_2kg43duu9j.b[6][0]++, el) && (cov_2kg43duu9j.b[6][1]++, el.parentNode)) {
      cov_2kg43duu9j.b[5][0]++;
      cov_2kg43duu9j.s[17]++;
      el.parentNode.removeChild(el);
    } else {
      cov_2kg43duu9j.b[5][1]++;
    }

    cov_2kg43duu9j.s[18]++;
    delete elements[type];
  } else {
    cov_2kg43duu9j.b[4][1]++;
  }

  cov_2kg43duu9j.s[19]++;

  if (components[type]) {
    cov_2kg43duu9j.b[7][0]++;
    cov_2kg43duu9j.s[20]++;
    delete components[type];
  } else {
    cov_2kg43duu9j.b[7][1]++;
  }
}
export function getComponent(_ref) {
  var _this = this;

  var position = _ref.position,
      container = _ref.container;
  cov_2kg43duu9j.f[2]++;
  cov_2kg43duu9j.s[21]++;
  return new Promise(function (resolve) {
    cov_2kg43duu9j.f[3]++;
    var component = (cov_2kg43duu9j.s[22]++, components[position]);
    cov_2kg43duu9j.s[23]++;

    if (component) {
      cov_2kg43duu9j.b[8][0]++;
      cov_2kg43duu9j.s[24]++;
      resolve(component);
    } else {
      cov_2kg43duu9j.b[8][1]++;
      cov_2kg43duu9j.s[25]++;
      ReactDOM.render(
      /*#__PURE__*/
      React.createElement(Container, {
        ref: function ref(comp) {
          cov_2kg43duu9j.f[4]++;
          cov_2kg43duu9j.s[26]++;
          components[position] = comp;
          cov_2kg43duu9j.s[27]++;
          resolve(comp);
        },
        onDestory: destroy.bind(null, position),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 9
        }
      }), getElement(position, container));
    }
  });
}